export default __webpack_public_path__ + "static/media/eth.381a1cbd.svg";